import { render } from "./i-paraphrase.vue?vue&type=template&id=47a4a0b1"
import script from "./i-paraphrase.vue?vue&type=script&lang=js"
export * from "./i-paraphrase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__